import React, { ReactNode } from "react";
import { IStyleProps } from "@/src/app/interface";
import classnames from "classnames";
import stl from "./rxTitle.module.scss";
import LinkWithUP from "../LinkWithUP";
interface IRxTitleProps extends IStyleProps {
    title: ReactNode;
    details?: ReactNode;
    classes?: Partial<{
        title: string;
        description: string;
    }>;
}
const RxTitle: React.FC<React.PropsWithChildren<IRxTitleProps>> = (props) => {
    return (
        <div
            className={classnames(stl["rxTitle"], props.className)}
            style={props.style}
        >
            <div
                className={classnames(
                    stl["title-container"],
                    props.classes?.title,
                )}
            >
                <span className={classnames(stl["title"])}>{props.title}</span>
                {props.children && (
                    <LinkWithUP classes={{ icon: stl["faq-icon"] }}>
                        {props.children}
                    </LinkWithUP>
                )}
            </div>
            {props.details && (
                <span
                    className={classnames(
                        stl["detail"],
                        props.classes?.description,
                    )}
                >
                    {props.details}
                </span>
            )}
        </div>
    );
};

export default RxTitle;
